enum SkipLinkIdentifier {
  MAIN = "main",
  SIDEBAR_NAVIGATION = "sidebar-navigation",
}

const FocusableSelectors = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
];

export interface SkipLinkModel {
  isScreenReaderVisibilityEnabled?: boolean;
  skipToMainLinkLabel: string;
  skipToSidebarNavigationLinkLabel?: string;
}

export interface SkipLinkStyleModel {
  isScreenReaderVisibilityEnabled: boolean;
}

export interface SkipLinkAnchorProps {
  href: string;
  label: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isScreenReaderVisibilityEnabled?: boolean;
}

export { SkipLinkIdentifier, FocusableSelectors };
